class NotificationService {
    constructor(notification) {
        return {
            error: (message, config) => {
                if (!message) {
                    return
                }
                notification.error(prepareNotification(message, config));
            },

            success: (message, config) => {
                if (!message) {
                    return
                }
                notification.success(prepareNotification(message, config));
            }
        };

        function prepareNotification(message, partialConfig) {
            return {
                message,
                delay: partialConfig?.delay ||  5000,
                positionY: "bottom",
                positionX: "right"
            }
        }
    }

}

angular.module('cpm')
    .service('NotificationService', ['Notification', NotificationService]);
